const state = {
  company_name: null,
  position_catch_copy: null,
  specialty_id: null
};

const actions = {
  initData({ dispatch }, position_information = {}) {
    dispatch('setCompanyName', position_information.company_name);
    dispatch('setPositionCatchCopy', position_information.position_catch_copy);
    dispatch('setSpecialtyId', position_information.specialty_id);
  },
  setCompanyName({ commit }, value) {
    commit('SET_COMPANY_NAME', value);
  },
  setPositionCatchCopy({ commit }, value) {
    commit('SET_POSITION_CATCH_COPY', value);
  },
  setSpecialtyId({ commit }, specialtyId) {
    commit('SET_SPECIALTY_ID', specialtyId);
  }
};

const mutations = {
  SET_COMPANY_NAME(state, value) {
    state.company_name = value;
  },
  SET_POSITION_CATCH_COPY(state, value) {
    state.position_catch_copy = value;
  },
  SET_SPECIALTY_ID(state, value) {
    state.specialtyId = value;
  }
};

export default {
  namespaced: true,
  state: () => state,
  actions,
  mutations
};